import React from 'react';

const MaintenanceMode = () => {
    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
                <h1 className="text-3xl font-bold text-gray-800 mb-4">Website Under Construction</h1>
                <p className="text-gray-600 mb-6">
                    We're currently working hard to improve our site. Please check back later.
                </p>
                {/* Replace with a fun, construction-related GIF URL */}
                <img
                    src="https://media.giphy.com/media/3o7527pa7qs9kCG78A/giphy.gif"  // Example GIF - adjust as needed
                    alt="Under Construction"
                    className="mx-auto rounded-md mb-6 max-w-[80%]" //Added max-w
                />
                <p className="text-gray-700 text-lg">
                    We apologize for any inconvenience.
                </p>
            </div>
        </div>
    );
};

export default MaintenanceMode;
